import type { CommandBody } from '../CrossOriginMessage';

/**
 * Used to ask for the user's geographic position.
 */
export class UserPositionRequestCommandBody implements CommandBody {}
